import React from 'react'
import { Button, Col } from 'reactstrap'
import queryString from 'query-string'
import { Link } from 'react-router-dom'

export default function ActionButtonSecondary({ id, actionId, history, search }) {
  // creates a new query pointing to this action block
  let qs = queryString.parse(search)
  let newQuery = {
    ...qs,
    r: id
  }

  // if this action block already open, query points to closing it
  let active = ''
  if (id === actionId && !qs.m) {
    active = 'active '
    delete newQuery.r
  }
  delete newQuery.m
  const link = queryString.stringify(newQuery)

  return (
    <span className='action-button edit-button'>
      <Link to={`?${link}`}><Button className={`action-button edit`} style={{"width": "100%", "height":"30px","borderRadius":"0 0 0 6px", "backgroundColor":"#334c59"}}>{"Edit"}</Button></Link>
    </span>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/InfoCard/ActionButtonSecondary.js